// extracted by mini-css-extract-plugin
export default {"infoIcon":"HelpComponent_infoIcon__Abx64"};